module.exports = __webpack_public_path__ + "static/media/chevron-bottom.2de2dbef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/iconic/chevron-bottom.svg
// module id = 1340
// module chunks = 0